import {
  GetInitialUserDocument,
  GetInitialUserQuery,
  GetInitialUserQueryVariables,
} from 'gqlTypes'
import { ErrorHandler } from 'modules/tracing'
import { useApolloClient } from 'react-apollo'

export const useFetchInitialUser = () => {
  const apolloClient = useApolloClient()

  return async () => {
    try {
      const { data } = await apolloClient.query<
        GetInitialUserQuery,
        GetInitialUserQueryVariables
      >({
        query: GetInitialUserDocument,
        fetchPolicy: 'network-only',
      })

      return data?.me
    } catch (e) {
      ErrorHandler.ignore(e, 'Unable to get initial user')
      return undefined
    }
  }
}
